import { render, staticRenderFns } from "./ProfesorInicio.vue?vue&type=template&id=19e5fffb&"
import script from "./ProfesorInicio.vue?vue&type=script&lang=js&"
export * from "./ProfesorInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports